import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { StandardTable } from '../../_components/table/standard.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { ethnicOriginsService } from '../../_services/ethnicOrigins.service';
import { EthnicOriginsManageDrawer } from './ethnicOrigins-manageDrawer';

export function EthnicOriginsIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await ethnicOriginsService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'other',
                header: 'Other',
            },
            {
                accessorKey: 'isActive',
                header: 'Status',
                Cell: ({ row }) => (
                    <>{row.original.isActive ? "Active" : "Inactive"}</>
                ),
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="Ethnic Origins" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Name", name: "name", onChange: setFilter, value: filter.name },
            ]} />

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>
                <Route path="Create" element={<EthnicOriginsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:id" element={<EthnicOriginsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
